import BasicButton from "components/General/BasicButton";
import { useNavigate } from "react-router-dom"

import { landTypes } from "utils/game-information-constants";
import InfoPopout from "components/Wrappers/InfoPopout";
import { LandToolTips } from "utils/ToolTipConst";
export default function LandLegend() {
  const lands = Object.values(landTypes).filter(land => land.name !== "culture"); // culture does not exist in the game

  return (

    <div className="flex flex-row space-x-4 p-2 overflow-x-auto">
      {lands.map((land, index) => (
        <div key={index} className="flex flex-col items-center">
          <div className="border border-black rounded h-10 w-10" style={{ backgroundColor: land.color }} />
          <label className="text-sm text-center">{land.name}</label>

          <InfoPopout
            maxWidth={400}
            popupContent={LandToolTips[land.name] ?? (<div>A biome</div>)} />
        </div>
      ))}
    </div>

  );
}
